import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Navbar } from "../components/Navbar";
import { Hero } from "../components/Hero";
import { Marquee } from "../components/Marquee";
import { Collections } from "../components/Collections";
import { WhyUs } from "../components/WhyUs";
import { SoldArchive } from "../components/SoldArchive";
import { BespokeSearch } from "../components/BespokeSearch";
import { Process } from "../components/Process";
import { ConciergePartner } from "../components/ConciergePartner";
import { Contact } from "../components/Contact";
import { Footer } from "../components/Footer";
import { RequestDialog } from "../components/RequestDialog";
import { scrollToSection } from "../lib/constants";

export default function Landing() {
  const [accessOpen, setAccessOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    if (location.state?.scrollTo) {
      const target = location.state.scrollTo;
      setTimeout(() => scrollToSection(target), 400);
    }
  }, [location.state]);

  return (
    <div className="bg-white overflow-x-hidden">
      <Navbar />
      <Hero onPrivateAccess={() => setAccessOpen(true)} />
      <Marquee />
      <Collections />
      <WhyUs />
      <SoldArchive />
      <BespokeSearch />
      <Process />
      <ConciergePartner />
      <Contact />
      <Footer />

      <RequestDialog
        open={accessOpen}
        onOpenChange={setAccessOpen}
        kind="private_access"
        title="Request Private Access"
        subtitle="Join a private circle with access to unlisted opportunities."
      />
    </div>
  );
}
